import {
    getFirestore,
    collection,
    getDocs,
    updateDoc,
    doc,
    getDoc,
    Timestamp,
    deleteDoc,
    addDoc,
} from "firebase/firestore";
import { ErrorHelper } from "../helpers/ErrorHelper";
import { FireHelper } from "../helpers/FireHelper";
import { Firebase } from "../FirebaseApp";
import { toast } from "react-toastify";

export const CategoryController = {
    db: getFirestore(Firebase),

    ToFirestoreBoatType: function (data) {
        let updatedData = {
            id: data.id,
            name: data.name,
            name_normalized: data.name_normalized,
            description: data.description,
            created_at: data.created_at ?? Timestamp.now(),
            updated_at: Timestamp.now(),
        };
        return FireHelper.ToFirestoreDoc(updatedData);
    },

    Insert: async function (data, res) {
        try {
          const inviteRef = collection(this.db, "products_categories");
          const result = await addDoc(inviteRef, this.ToFirestoreBoatType(data));
    
          res(result.id);
        } catch (e) {
          toast(ErrorHelper.HandleMessage(e));
        }
      },

    Update: async function (data, res) {
        try {
            const frankDocRef = doc(this.db, "products_categories", data.id);
            await updateDoc(frankDocRef, this.ToFirestoreBoatType(data));
        } catch (e) {
            toast(ErrorHelper.HandleMessage(e));
        }
    },

    List: async function (res) {
        const querySnapshot = await getDocs(
            collection(this.db, "products_categories")
        );
        const results = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        res(results);
    },
    
  Delete: async function (id) {
    await deleteDoc(doc(this.db, "products_categories", id));
    return true;
  },
};
